module.exports = __webpack_public_path__ + "static/woman-headshot-square.7bcf3f03.jpg";